import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const SidebarContainer = styled.div<{ $isOpen: boolean }>`
  width: ${({ $isOpen }) => ($isOpen ? '260px' : '52px')};
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${colors.gray210};
  background: ${colors.gray150};
  transition: width 0.25s ease;
`

export const SidebarInner = styled.div`
  width: 260px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const SidebarTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  padding: 10px 8px 8px;
  flex-shrink: 0;
`

export const NewChatButton = styled.button`
  display: flex;
  align-items: center;
  padding: 6px 4px;
  color: ${colors.black};
  border: none;
  border-radius: 8px;
  font-family: inherit;
  cursor: pointer;
  background: unset;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 12px;
  gap: 12px;

  svg {
    font-size: 28px;
    border-radius: 18px;
    background: #dfdfdf;
    padding: 2px;
  }

  &:hover {
    opacity: 0.7;
  }
`

export const CollapseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  background: transparent;
  border: none;
  border-radius: 18px;
  color: ${colors.gray380};
  cursor: pointer;

  &:hover {
    background: ${colors.gray200};
    color: ${colors.gray900};
  }
`

export const CollapsedColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 10px 0 0;
  width: 52px;
`

export const IconOnlyButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: none;
  border-radius: 18px;
  color: ${colors.gray380};
  cursor: pointer;

  &:hover {
    background: ${colors.gray200};
    color: ${colors.gray900};
  }
`

export const NewChatIconButton = styled(IconOnlyButton)`
  background: #dfdfdf;
  color: ${colors.black};

  svg {
    font-size: 24px;
  }
`

export const ConversationsLabel = styled.p`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${colors.gray300};
  margin: 16px 12px 4px;
  flex-shrink: 0;
`

export const ConversationsList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 8px 8px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.gray850};
    border-radius: 2px;
  }
`

export const ConversationItem = styled.button<{ $isActive: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: ${({ $isActive }) => ($isActive ? colors.gray200 : 'transparent')};
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  font-size: 13px;
  color: ${colors.gray380};
  font-weight: ${({ $isActive }) => ($isActive ? 600 : 400)};
  margin-bottom: 2px;
  transition: background 0.15s ease;

  &:hover {
    background: ${({ $isActive }) => ($isActive ? colors.gray210 : colors.gray200)};
  }
`

export const ConversationTitle = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const DeleteButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: ${colors.gray300};
  flex-shrink: 0;
  opacity: 0;
  transition:
    opacity 0.15s ease,
    color 0.15s ease;

  ${ConversationItem}:hover & {
    opacity: 1;
  }

  &:hover {
    color: ${colors.red300};
  }
`
